import { Paper } from '@mui/material'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const SubMenuContainer = (props: Props) => {
  const { children } = props
  return (
    <Paper elevation={8} sx={{ py: 1 }}>
      {children}
    </Paper>
  )
}
